import React, { ReactElement } from "react";

import Profile from "components/Profile";
import Section from "components/Section";
import { Container } from "style/components/Page";

import {
    Wrapper,
    Employees,
    Letter,
    Heading,
} from "./EmployeesByLetter.styled";
import EmployeesByLetterProps from "./EmployeesByLetterProps";
const EmployeesByLetter = ({
    heading,
    employeesByLetter,
    theme = "lightgray",
    anchorName,
}: EmployeesByLetterProps): ReactElement => {
    return (
        <Section alignItems="center" theme={theme} id={anchorName}>
            <Container>
                <Heading>{heading}</Heading>
                {employeesByLetter?.map((letter, index) => (
                    <Wrapper key={`EmployeesByLetter${index}`}>
                        {letter.heading && <Letter>{letter.heading}</Letter>}
                        <Employees>
                            {letter.items?.map((employee, index) => {
                                if (employee.description)
                                    delete employee.description;
                                return (
                                    <Profile
                                        key={`Employee${index}`}
                                        {...employee}
                                    />
                                );
                            })}
                        </Employees>
                    </Wrapper>
                ))}
            </Container>
        </Section>
    );
};

export default React.memo(EmployeesByLetter);
